export * from './resources.component';